function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.35,
    height: 12.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8026666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 6.02,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.04,
    width: 21.35,
    height: 12.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 18.45,
    fontFamily: "Arial"
  }, "\n        Norton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.86,
    width: 21.35,
    height: 12.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9869230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 31.275,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37.69,
    width: 21.35,
    height: 16.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5045454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 45.964999999999996,
    fontFamily: "Arial"
  }, "\n        Buena_Vista\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.24,
    width: 21.35,
    height: 17.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4899999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 62.955,
    fontFamily: "Arial"
  }, "\n        Emporia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71.66,
    width: 21.35,
    height: 17.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9922222222222221
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 80.625,
    fontFamily: "Arial"
  }, "\n        Lexington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.59,
    width: 21.35,
    height: 18.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6836363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 98.85000000000001,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108.11,
    width: 21.35,
    height: 18.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7079999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 117.38,
    fontFamily: "Arial"
  }, "\n        Galax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.65,
    width: 21.35,
    height: 18.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0611111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 135.925,
    fontFamily: "Arial"
  }, "\n        Covington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.2,
    width: 21.35,
    height: 20.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9214285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 155.42499999999998,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.65,
    width: 21.35,
    height: 20.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7408333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 176.095,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.53,
    width: 21.35,
    height: 21.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6423076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 197.34,
    fontFamily: "Arial"
  }, "\n        Manassas_Park\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.15,
    width: 21.35,
    height: 22.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7791666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 219.41,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230.67,
    width: 21.35,
    height: 23.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0166666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 242.64499999999998,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.62,
    width: 21.35,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 266.975,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.33,
    width: 21.35,
    height: 25.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1236842105263158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 292.175,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.01,
    width: 21.35,
    height: 26.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 318.375,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 331.75,
    width: 21.35,
    height: 27.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7791666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 345.28,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.81,
    width: 21.35,
    height: 29.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2558823529411764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 373.5,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 388.19,
    width: 21.35,
    height: 29.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1236842105263158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 402.905,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 417.62,
    width: 21.35,
    height: 31.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7791666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 433.225,
    fontFamily: "Arial"
  }, "\n        Williamsburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 448.83,
    width: 21.35,
    height: 32.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7791666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 464.88,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.93,
    width: 21.35,
    height: 32.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1861111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 497.29,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 513.65,
    width: 21.35,
    height: 32.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6423076923076925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 530.01,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 546.37,
    width: 21.35,
    height: 37.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0500000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 565,
    fontFamily: "Arial"
  }, "\n        Radford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 583.64,
    width: 21.35,
    height: 38.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.334375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 602.87,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.1,
    width: 21.35,
    height: 38.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5250000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 641.405,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 660.72,
    width: 21.35,
    height: 39.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.334375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.675,
    y: 680.36,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 0,
    width: 27.99,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.153076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.345,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.34,
    y: 0,
    width: 28.6,
    height: 30.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.588888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.64,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.93,
    y: 0,
    width: 29.19,
    height: 30.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.824375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.525,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.13,
    y: 0,
    width: 29.39,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.099285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.82499999999999,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.51,
    y: 0,
    width: 29.95,
    height: 30.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.871875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.48499999999999,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 0,
    width: 30.89,
    height: 30.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.353846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.905,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.35,
    y: 0,
    width: 31.64,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.353846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.17,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.98,
    y: 0,
    width: 31.88,
    height: 30.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.92,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.86,
    y: 0,
    width: 31.89,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.805,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.75,
    y: 0,
    width: 32.1,
    height: 30.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.8,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.85,
    y: 0,
    width: 32.69,
    height: 30.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5500000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.19500000000005,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Falls_Church\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.55,
    y: 0,
    width: 32.76,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4571428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.93,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.31,
    y: 0,
    width: 33.28,
    height: 30.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5500000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.95,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Martinsville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.6,
    y: 0,
    width: 33.55,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5500000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.375,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.14,
    y: 0,
    width: 33.72,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6105263157894738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.87,
    y: 0,
    width: 34.21,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7000000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.975,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.07,
    y: 0,
    width: 34.26,
    height: 30.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.2,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Poquoson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.33,
    y: 0,
    width: 34.65,
    height: 30.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.6550000000001,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.98,
    y: 0,
    width: 35.06,
    height: 30.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.51,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.04,
    y: 0,
    width: 35.22,
    height: 30.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6105263157894738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.65,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 664.26,
    y: 0,
    width: 35.74,
    height: 30.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.13,
    y: 15.3,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 30.6,
    width: 35.17,
    height: 31.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4046153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 46.230000000000004,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 61.86,
    width: 35.17,
    height: 31.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.562857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 77.83,
    fontFamily: "Arial"
  }, "\n        Bristol\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 93.79,
    width: 35.17,
    height: 32.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6179999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 109.97,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 126.16,
    width: 35.17,
    height: 33.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.427142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 143.15,
    fontFamily: "Arial"
  }, "\n        Fredericksburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 160.14,
    width: 35.17,
    height: 34.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8972222222222221
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 177.21499999999997,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 194.29,
    width: 35.17,
    height: 34.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.890833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 211.635,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 228.98,
    width: 35.17,
    height: 34.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4892857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 246.405,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 263.83,
    width: 35.17,
    height: 35.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.39625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 281.575,
    fontFamily: "Arial"
  }, "\n        Hopewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 299.32,
    width: 35.17,
    height: 36.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5170000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 317.38,
    fontFamily: "Arial"
  }, "\n        Waynesboro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 335.45,
    width: 35.17,
    height: 36.75,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.198125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 353.825,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 372.2,
    width: 35.17,
    height: 37.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5121428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 390.98,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 409.76,
    width: 35.17,
    height: 39.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.198125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 429.55,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 449.34,
    width: 35.17,
    height: 39.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0688235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 469.245,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 489.16,
    width: 35.17,
    height: 40.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5170000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 509.21500000000003,
    fontFamily: "Arial"
  }, "\n        Winchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 529.27,
    width: 35.17,
    height: 40.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1972727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 549.605,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 569.94,
    width: 35.17,
    height: 42.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.344666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 591.1800000000001,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 612.41,
    width: 35.17,
    height: 43.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.39625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 634.0649999999999,
    fontFamily: "Arial"
  }, "\n        Staunton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.35,
    y: 655.72,
    width: 35.17,
    height: 44.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.344666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.935,
    y: 677.86,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 30.6,
    width: 37.69,
    height: 41.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7689999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.36500000000001,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.21,
    y: 30.6,
    width: 37.82,
    height: 41.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.36375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.11999999999999,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.03,
    y: 30.6,
    width: 39.36,
    height: 41.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.71,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.39,
    y: 30.6,
    width: 40.22,
    height: 41.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.5,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.61,
    y: 30.6,
    width: 41.17,
    height: 41.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.881428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.19500000000002,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Fairfax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.79,
    y: 30.6,
    width: 41.84,
    height: 41.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.767333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.71,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.63,
    y: 30.6,
    width: 42.47,
    height: 41.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.767333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.865,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.1,
    y: 30.6,
    width: 42.91,
    height: 41.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4591666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.555,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Harrisonburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 30.6,
    width: 43.5,
    height: 41.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.193076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.75,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 30.6,
    width: 44.06,
    height: 41.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4591666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.53,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.56,
    y: 30.6,
    width: 45.17,
    height: 41.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.193076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.145,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.73,
    y: 30.6,
    width: 46.41,
    height: 41.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.302
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.9350000000001,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Salem\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.13,
    y: 30.6,
    width: 46.5,
    height: 41.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.38,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.63,
    y: 30.6,
    width: 46.97,
    height: 41.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.115,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.6,
    y: 30.6,
    width: 47.4,
    height: 41.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.3000000000001,
    y: 51.355000000000004,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 72.11,
    width: 45.52,
    height: 43.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3469999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 93.845,
    fontFamily: "Arial"
  }, "\n        Petersburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 115.58,
    width: 45.52,
    height: 43.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3753846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 137.52,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 159.45,
    width: 45.52,
    height: 45.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.528888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 182.345,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 205.25,
    width: 45.52,
    height: 46.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.251428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 228.26,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 251.27,
    width: 45.52,
    height: 46.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 274.33500000000004,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 297.4,
    width: 45.52,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.034666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 320.83,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 344.26,
    width: 45.52,
    height: 48.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.034666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 368.315,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 392.37,
    width: 45.52,
    height: 48.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 416.75,
    fontFamily: "Arial"
  }, "\n        Manassas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 441.13,
    width: 45.52,
    height: 49.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.251428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 466.075,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 491.02,
    width: 45.52,
    height: 50.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2760000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 516.465,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 541.91,
    width: 45.52,
    height: 51.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.034666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 567.89,
    fontFamily: "Arial"
  }, "\n        Charlottesville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 593.87,
    width: 45.52,
    height: 52.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.138181818181819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 620.02,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 646.17,
    width: 45.52,
    height: 53.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6776470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 673.0849999999999,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 72.11,
    width: 45.91,
    height: 53.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.869375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.995,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.95,
    y: 72.11,
    width: 46.68,
    height: 53.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.334285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.29,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.63,
    y: 72.11,
    width: 47.94,
    height: 53.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.6,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.58,
    y: 72.11,
    width: 54.22,
    height: 53.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.594666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.69,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 72.11,
    width: 60.73,
    height: 53.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.165,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Danville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.53,
    y: 72.11,
    width: 62.46,
    height: 53.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.594666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.76,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.99,
    y: 72.11,
    width: 67.09,
    height: 53.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.171764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.535,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.08,
    y: 72.11,
    width: 67.43,
    height: 53.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.594666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.795,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.51,
    y: 72.11,
    width: 71.2,
    height: 53.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.493333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.11,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.72,
    y: 72.11,
    width: 74.28,
    height: 53.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.86,
    y: 99.07,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 126.03,
    width: 68.68,
    height: 61.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.076666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 156.605,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 187.18,
    width: 68.68,
    height: 61.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.802222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 217.79000000000002,
    fontFamily: "Arial"
  }, "\n        Lynchburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 248.4,
    width: 68.68,
    height: 62.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6758823529411764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 279.645,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 310.89,
    width: 68.68,
    height: 63.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3247368421052634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 342.47499999999997,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 374.05,
    width: 68.68,
    height: 63.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.751764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 405.94,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 437.84,
    width: 68.68,
    height: 64.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.819999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 469.84999999999997,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 501.86,
    width: 68.68,
    height: 64.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.175714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 533.975,
    fontFamily: "Arial"
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 566.09,
    width: 68.68,
    height: 65.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.700714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 598.995,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.04,
    y: 631.9,
    width: 68.68,
    height: 68.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.38,
    y: 665.9499999999999,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 126.03,
    width: 58.97,
    height: 82.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4688235294117646
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.20499999999998,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.69,
    y: 126.03,
    width: 72.61,
    height: 82.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.372857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.995,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Roanoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.31,
    y: 126.03,
    width: 74.36,
    height: 82.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.957333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.49,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.67,
    y: 126.03,
    width: 76.04,
    height: 82.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.002105263157895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.69,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.71,
    y: 126.03,
    width: 76.99,
    height: 82.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.699
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.205,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Portsmouth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.7,
    y: 126.03,
    width: 80.01,
    height: 82.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.000625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.705,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.7,
    y: 126.03,
    width: 90.3,
    height: 82.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.884285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.85,
    y: 167.22,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 208.41,
    width: 96.67,
    height: 79.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.659285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.055,
    y: 248.025,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 287.63,
    width: 96.67,
    height: 88.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.65857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.055,
    y: 331.935,
    fontFamily: "Arial"
  }, "\n        Hampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 376.24,
    width: 96.67,
    height: 102.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.055,
    y: 427.31,
    fontFamily: "Arial"
  }, "\n        Alexandria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 478.38,
    width: 96.67,
    height: 107,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.055833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.055,
    y: 531.88,
    fontFamily: "Arial"
  }, "\n        Newport_News\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 585.38,
    width: 96.67,
    height: 114.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.055,
    y: 642.69,
    fontFamily: "Arial"
  }, "\n        Norfolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.38,
    y: 208.41,
    width: 95.16,
    height: 123.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.96,
    y: 270.37,
    fontFamily: "Arial"
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.54,
    y: 208.41,
    width: 107.65,
    height: 123.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.365,
    y: 270.37,
    fontFamily: "Arial"
  }, "\n        Chesapeake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.2,
    y: 208.41,
    width: 109.2,
    height: 123.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.8,
    y: 270.37,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.39,
    y: 208.41,
    width: 120.61,
    height: 123.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.538125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.6949999999999,
    y: 270.37,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.38,
    y: 332.33,
    width: 158.46,
    height: 113.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.402857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.61,
    y: 389.06,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.38,
    y: 445.79,
    width: 158.46,
    height: 125.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.591578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.61,
    y: 508.41,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.38,
    y: 571.03,
    width: 158.46,
    height: 128.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.212142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.61,
    y: 635.515,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.84,
    y: 332.33,
    width: 274.16,
    height: 97.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.979285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.92,
    y: 381.185,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.84,
    y: 430.04,
    width: 274.16,
    height: 269.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.282857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.92,
    y: 565.02,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.ad0e61b55494ca3213c07b8457718378.svg";
export { ForwardRef as ReactComponent };